export const MODAL_IMAGE_LARGE_SIZE = 800;
export const MODAL_IMAGE_SMALL_SIZE = 400;
export const TARGET_MAX_WIDTH = 800;

export const EXCLUDEDROUTES = ["/account", "/results/details"];

export const DEFAULT_IMAGE = "/assets/v2/images/default-room-image.png";

export const DISCOUNT_TYPES = {
  WALLET: "wallet",
  PROMO_CODE: "promocode",
};

export const BOOKING_ENTITIES = {
  HOTEL: "hotel",
  FLIGHT: "flight",
};
